import { Location } from 'vue-router'
import { CollectorPublication as Data, Session } from '@/typings/api/CollectorPublication'
import {
  createEdit, createView,
} from '@/helpers/enums/table-actions'
import { COLLECTOR_PUBLICATIONS_ROUTES as ROUTES } from './utils'


const getEditRoute = (data: Data): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.publication_id.toString() },
})

const getViewRoute = (data: Data): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.publication_id.toString() },
})

export const getSessionNames = (data: Data, sessions: Session[]) => {
  if (sessions?.length > 0 && data.session_digit_code) {
    return sessions.filter(({ digit_code }) => digit_code === data.session_digit_code).map(({ name }) => name).join(', ')
  }

  return ''
}

export const TABLE_ACTIONS_ADMIN = Object.freeze([
  createView<Data>(getViewRoute),
])

export const TABLE_ACTIONS = Object.freeze([
  createEdit<Data>(getEditRoute),
])

export const BASE_TABLE_HEADERS = [
  {
    text: 'Публикация',
    value: 'name',
    sortable: false,
    getRoute: getViewRoute,
  },
  {
    text: 'Хранилище КИМ',
    value: 'lk_storage_name',
    sortable: false,
  },
  {
    text: 'Хранилище Критериев',
    value: 'lk_criteria_storage_name',
    sortable: false,
  },
  {
    text: 'Оценочная процедура',
    value: 'procedure_name',
    sortable: false,
  },
  {
    text: 'Сессия',
    value: 'session_name',
    sortable: false,
  },
  {
    text: 'Предмет',
    value: 'subject_name',
    sortable: true,
  },
  {
    text: 'Количество участников',
    value: 'participants_count',
    sortable: true,
    width: 136,
  },
]

export const TABLE_HEADERS = Object.freeze([
  ...BASE_TABLE_HEADERS,
])
